// API URLs
//callback.arthpay.com/srvc-uat-one
// export const APIBASEURL = "http://localhost:8081";//local
// export const APIBASEURL = "http://172.20.50.2:7001";//server uat

import { CookieAttributes } from "next-client-cookies";

// export const APIBASEURL = "https://api.arthpay.com/srvc-uat-one";
export const APIBASEURL = "https://api.arthpay.com/srvc-uat-one";//server dev
export const RTSBASEURL = "https://api.arthpay.com";
export const RTSBASEURLSALES = "https://api.arthpay.com/sales/api";
export const APIBASEURLMAILER = "https://api.arthpay.com/mailer";
export const API_TUT_BASE_URL = "https://api.arthpay.com/tutelar"
export const API_JASPER_REPORT = "https://api.arthpay.com/jasper-report"
// export const RTSBASEURL = "https://api.arthpay.com";


export const GET_TNC_REPORT_ENDPOINT = "/admin/data/getTnCReport";
export const GET_TNC_DOWNLOAD_ENDPOINT = "/admin/data/tnc/download";

// const API_BASE_URL   = "https://uat-api.arthpay.com"

// export const APIBASEURL = "http://localhost:8080"
// export const UPI_APIBASEURL = "http://localhost:8080/api/upi";
export const UPI_APIBASEURL = "https://api.arthpay.com/upi";
// export const UPI_APIBASEURL = "https://uat-api.arthpay.com/upi";

export const KAFKA_CLIENT_ID = "papg-admin-ui"
// export const KAFKA_BROKERS = "172.20.50.2:9092"
export const KAFKA_BROKERS = "10.10.204.145:9092"

// export const YPP_APIBASEURL = "http://localhost:8080";
export const YPP_APIBASEURL = "https://api.arthpay.com/disbursement";
// export const YPP_APIBASEURL = "https://uat-api.arthpay.com/disbursement";
// export const YPP_APIBASEURL = "http://172.20.10.14:7005";

export const VERIFICATION_ENVIRONMENT_PROD:string = "PROD";
export const VERIFICATION_ENVIRONMENT_UAT:string = "UAT";
export const CURRENT_VERIFICATION_ENV:string = VERIFICATION_ENVIRONMENT_PROD;

export const VPA_HANDLER_PROD:string = "@ypbiz";
export const VPA_HANDLER_UAT:string = "@yesipay";

// USER LOGIN
export const LOGIN_USR_STTS_KEY = "LOGIN_USR_STTS";
export const LOGIN_USR_STTS_VAL_ACTIVE = "ACTIVE";
export const LOGIN_USR_STTS_VAL_INACTIVE = "INACTIVE";

export const LOGIN_ERR_MSG = "lgremns";
export const CURRENT_MODE_PG = "PG";
export const CURRENT_MODE_UPI = "UPI";
export const CURRENT_MODE_ADJUSTMENT = "ADJUSTMENT";
export const CURRENT_MODE_ECOLLECT = "ECOLLECT";

// CHARGEBACK STAGE
export const CHARGEBACK_STAGE_FRAUD_CHAREBACK = "FRAUD_CHAREBACK";

// CHARGEBACK STATUS
export const CHARGEBACK_STATUS_OPEN = "OPEN";
export const CHARGEBACK_STATUS_UNDER_REVIEW = "UNDER_REVIEW";
export const CHARGEBACK_STATUS_FRAUD_CHARGEBACK = "FRAUD_CHARGEBACK";
export const CHARGEBACK_STATUS_INITIATED = "INITIATED";
export const CHARGEBACK_STATUS_ACCEPTED = "ACCEPTED";
export const CHARGEBACK_STATUS_REJECTED = "REJECTED";
export const CHARGEBACK_STATUS_ACCEPT_AND_CLOSED = "ACCEPT_AND_CLOSED";
export const CHARGEBACK_STATUS_REJECT_AND_CLOSED = "REJECT_AND_CLOSED";
export const CHARGEBACK_STATUS_WON = "WON";
export const CHARGEBACK_STATUS_LOST = "LOST";
export const CHARGEBACK_STATUS_CLOSED = "CLOSED";
export const CHARGEBACK_STATUS_SENT_TO_BANK = "SENT_TO_BANK";
export const CHARGEBACK_STATUS_TAT_EXPIRED = "TAT_EXPIRED";
export const CHARGEBACK_FILE_STATUS_UPLOADED = "UPLOADED";

export const CHARGEBACK_PROOF_TYPE_WON = "CB_WON_PROOF";
export const CHARGEBACK_PROOF_TYPE_LOST = "CB_LOST_PROOF";
export const CHARGEBACK_PROOF_TYPE_ACCEPT = "CB_ACPT_PROOF";
export const CHARGEBACK_PROOF_TYPE_REJECT = "CB_RJCT_PROOF";

// SETTLEMENT STATUS
export const SETTLEMENT_STATUS_IN_PROCESS = "IN_PROCESS";
export const SETTLEMENT_STATUS_COMPLETED = "COMPLETED";
export const SETTLEMENT_STATUS_FAILED = "FAILED";
export const SETTLEMENT_STATUS_TO_SETTLE = "TO_SETTLE";


// MERCHANT STATUS
export const APPROVE_MERCHANT_STATUS = "APPROVE";
export const REJECT_MERCHANT_STATUS = "REJECT";
export const MODIFY_MERCHANT_PENDING = "PENDING";

// MERCHANT APPROVAL TYPES
export const APPROVAL_TYPE_REJECT = "REJECTED"
export const APPROVAL_TYPE_PENDING = "PENDING"
export const APPROVAL_TYPE_APPROVE = "APPROVED"
export const APPROVAL_TYPE_UPDATED = "UPDATED"
export const APPROVAL_TYPE_CREATED = "CREATED"

export const APPROVAL_TYPE_INITIATED = "INITIATED"
export const APPROVAL_TYPE_ALREADY_UPLOADED = "ALREADY_UPLOADED"
export const APPROVAL_TYPE_VALIDATION_FAILED = "VALIDATION_FAILED"
export const APPROVAL_TYPE_EXCEEDS_LIMIT = "EXCEEDS_LIMIT"
export const APPROVAL_TYPE_PROCESSED = "PROCESSED"
export const APPROVAL_TYPE_INVALID_RRN = "INVALID_RRN"
export const APPROVAL_TYPE_EXPIRED_REFUND = "EXPIRED_REFUND"
export const APPROVAL_TYPE_EXCEEDS_UNSETTLED_AMT = "EXCEEDS_UNSETTLED_AMT";




// STATUS LIST
export const STTS_BOS_REJECTION = "BOS_REJECTION"
export const STTS_BOS_APPROVAL = "BOS_APPROVAL"
export const STTS_PENDING = "PENDING"

// MODAL TYPES
export const MODAL_TYPE_SUCCESS = "SUCCESS";
export const MODAL_TYPE_ERROR = "ERROR";
export const MODAL_TYPE_INFO = "INFO";
export const MODAL_TYPE_FAILURE = "FAILURE";
export const MODAL_TYPE_FAILED = "FAILED";
export const MODAL_TYPE_SETTLED = "SETTLED";
export const MODAL_TITLE_UPDATE = "Update";
export const MODAL_TEXT_UPDATE_SUCCESS = "Your Updated information has been saved successfully!";
export const MODAL_TEXT_UPDATE_FAILURE = "Updating information has encountered an error";
export const MODAL_TITLE_TEMP_SAVE = "Temporary Save";
export const MODAL_TEXT_TEMP_SAVE_SUCCESS = "Your credentials are successfully saved. You can login and continue at the same point if the sign up process is interrupted.";
export const MODAL_TEXT_TEMP_SAVE_FAILURE = "Unable to save your credentials. Please refresh and try again";

// ACCESS TYPES
export const LOGIN_USR_ACCESS_TYPE = "ACCESS_TYPE";
export const LOGIN_USR_ACCESS_TYPE_ALL = "ALL_USERS";
export const LOGIN_USR_ACCESS_TYPE_SUPERADMIN = "SUPERADMIN";
export const LOGIN_USR_ACCESS_TYPE_DEV = "DEVELOPER";
export const LOGIN_USR_ACCESS_TYPE_BO = "BO_USER";
export const LOGIN_USR_ACCESS_TYPE_COMPLIANCE = "COMPLIANCE";
export const LOGIN_USR_ACCESS_TYPE_BO_SUPERVISOR = "BO_SUPERVISOR";
export const LOFIN_USR_ACCESS_TYPE_AP_SUPERUSER = "AP_SUPERUSER";
export const LOGIN_USR_ACCESS_TYPE_ADMIN = "ADMIN_USER";
export const LOGIN_USR_ACCESS_TYPE_ADMIN_SUPERVISOR = "ADMIN_SUPERVISOR";
export const LOGIN_USR_ACCESS_TYPE_NOT_IN = "NOT_LOGGED_IN";
export const LOGIN_USR_MERCHFLAGUPI = "MERCHFLAGUPI";
export const LOGIN_USR_MERCHFLAGYPP = "MERCHFLAGYPP";
export const LOGIN_USR_MERCHFLAGBENE = "MERCHFLAGBENE";
export const LOGIN_USR_ALLOCATE_APPLICATION = "ALLOCATE_APPLICATION"

export const NEVIGATION_PANE_MAIN = "MAIN_PANE";
export const NEVIGATION_PANE_USER = "USER_PANE";

export const WEB_LINK_REGEX =   /^(https?:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/;

export const REGEX = {
    FULL_NAME:/^[-a-zA-Z._]+(\s[-a-zA-Z._]+)*(\s[-a-zA-Z._]+)?$/,
    EMAIL:/^[a-zA-Z0-9_.-]+(?:\.[a-zA-Z0-9._-]+)*@(?:[a-zA-Z-]+\.)+[a-zA-Z-]{2,10}$/,
    PASSWORD:/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=])(?=(?:.*[\d]){3})\S{12,}/,
    MOBILE_NUMBER:/^[6-9]\d{9}$/,
    PHONE_NUMBER:/([1-9]{1}[0-9]{9})/,
    SPECIAL_CHARACTER : /[^a-zA-Z0-9]/,
    PAN : /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
    ALPHANUMERIC : /[^a-zA-Z0-9]/g,
    AADHAR : /^\d{12}$/,
    PINCODE : /^\d{6}$/,
    GST: /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}Z[A-Z\d]{1}$/i,
    GSTNUM : /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z0-9]{1}[A-Z0-9]{1}[A-Z0-9]{1}$/,
    IP_REGEX: /((([A-Za-z]{4}[sS]{1}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
    CIN : /^[LU][0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/,
    LLP : /^[A-Za-z0-9/-]{5,20}$/,
    UDYAM: /^UDYAM-[A-Z]{2}-\d{2}-\d{7}$/,
}

export const LOGIN_OTP_TIMER = 60*2;
export const AADHAAR_OTP_TIMER = 60*10;
export const EIGHTEEN_YEARS = (18 * 365 * 24 * 60 * 60 * 1000) + (5 * 24 * 60 * 60 * 1000);


export const LOGIN_ENDPOINT = "/admin/access/login";
export const DEACTIVATE_MERCHANT_ENDPOINT = "/access/deactivate";
export const PENDING_MRCHNT_ENDPOINT = "/api/admin/data/getPendingMerchants";
export const GET_ALL_ADMIN_MAPPING_ENDPOINT = "/admin/application/getAdminMapping";
export const ADD_ADMIN_MAPPING_ENDPOINT = "/admin/application/addAdminMapping"
export const GET_ALL_UPDATE_ADMIN_MAPPING_ENDPOINT = "/admin/application/updateAdminMapping"
export const ACTIVE_MRCHNT_ENDPOINT = "/api/admin/data/getActiveMerchants";
export const GET_MRCHNT_INFO_ENDPOINT = '/api/admin/data/merchantInfo';
export const GET_ACTIVE_MRCHNT_INFO_ENDPOINT = '/api/admin/data/activeMerchantInfo';
export const GET_DEACTIVE_MRCHNT_INFO_ENDPOINT = '/api/admin/data/deActiveMerchantInfo';
export const GET_MRCHNT_AML_INFO_ENDPOINT = '/api/admin/data/merchantAmlInfo';
export const GET_MRCHNT_FILE_ENDPOINT = '/api/admin/data/getMerchantsFile';
export const GET_SALES_FILE_ENDPOINT = '/sales/file/upload';
export const GET_MDR_TABLE_ENDPOINT = "/api/admin/data/getMdrTable";
export const SEARCH_MERCHANT_FOR_MDR_ENDPOINT = "/api/admin/data/searchMerchant";
export const GET_ALL_MERCHANT_FOR_MDR_ENDPOINT = "/api/admin/data/getAllMerchantForMdr";
export const GET_ALL_PRODUCTS_FOR_MDR_ENDPOINT = "/api/admin/data/getAllProducts";
export const GET_ALL_TRANSACTION_TABLE_ENDPOINT = "/api/admin/data/getAllTransactions";
export const GET_ALL_SETTLEMENE_TABLE_ENDPOINT = "/api/admin/data/getAllSettlements";
export const UPDATE_MDR_TABLE_ENDPOINT = "/api/admin/data/addRowToMdr";
export const SEARCH_MDR_TABLE_ENDPOINT = "/api/admin/data/searchMdr"
export const GET_MERCHANT_BENE_INFO_ENDPOINT = "/api/admin/data/getBeneInfo"
export const ASSIGN_MDR_RATE_ENDPOINT = "/api/product/assignMdr";
export const GET_MDR_DROPDOWN_ENDPOINT = "/admin/ui/getMdrDropdown";
export const GET_ALL_CHARGEBACK_FILES_ENDPOINT ='/api/admin/data/getAllChargebackFiles';
export const GET_RTS_LIMIT_ENDPOINT = '/rts/limit';
export const RTS_SETTLE_ENDPOINT = "/rts/settle";
export const RTS_SCHEDULER_CHECK_ENDPOINT = '/rts/schedulerCheck';
export const RTS_START_SCHEDULER_ENDPOINT = '/rts/scheduler';
export const SET_FILES_ENDPOINT = '/api/admin/data/selectMerchantFiles';
export const GET_UPDATE_BANK_DETAILS_ENDPOINT = '/api/internal/data/findBankdetails';
export const GET_VERIFY_BANK_ACC_ENDPOINT = '/api/cashfree/verify/bankAccount';
export const GET_MERCHANT_CURRENT_BANK_DETAILS_ENDPOINT = '/admin/merchant/update/bankDetails';
export const GET_MERCHANT_UPDATED_DETAILS_ENDPOINT = "/admin/merchant/update/getUpdatedDetails"
export const GET_MERCHANT_CURRENT_VIEW_BANK_DETAILS_ENDPOINT = '/admin/merchant/update/viewBankDetails';
export const GET_MERCHANT_CURRENT_APPROVE_BANK_DETAILS_ENDPOINT = '/admin/merchant/update/approveBankDetails';
export const GET_MERCHANT_UPDATE_SETTLEMENT_MODE_ENDPOINT = '/admin/merchant/update/settlementMode';
export const GET_ALL_REFUND_MPR_GENERATE_ENDPOINT = "/reports/generate-mpr-file";
export const GET_ALL_REFUND_MIS_GENERATE_ENDPOINT = "/reports/generate-mis-file";
export const GET_ALL_ADMIN_SCREEN_ENDPOINT = "/admin/access/getAdminScreens"
export const GET_ADMIN_ACCESS_SCREEN_ENDPOINT = "/admin/access/getAdminAccess";
export const GET_VIEW_ADMIN_ACCESS_ENDPOINT = "/admin/access/viewAdminAccess";
export const GET_ACCESS_USER_ENDPOINT = "/admin/access/createAccessUser";
export const GET_ADMIN_ACCESS_SCREEN_MAPPING_ENDPOINT = "/admin/access/adminAccessScreenMapping"
export const GET_ADMIN_ACCESS_LANDING_PAGE_ENDPOINT = "/admin/access/selectLandingPage"
export const GET_RESELLER_ACCESS_ENDPOINT = "/reseller/getResellerAccess";
export const GET_ADMIN_USER_ENDPOINT = "/admin/access/getAllAdminUsers?token="
export const GET_UPDATE_ADMIN_USER_ENDPOINT = "/admin/access/updateAdminUser"
export const GET_UPDATE_ADMIN_STATUS_ENDPOINT = "/admin/access/updateAdminStatus"
export const GET_ACTIVE_MERCHANTS_DATA = "/api/files/getActiveMerchantsData"; 
export const GET_MERCHANT_SCHEME_MAPPING_ENDPOINT = "/api/product/getSchemeMapping";
export const UPDATE_ASSIGNED_MDR_ENDPOINT = "/api/product/updateSchemeMapping";

export const GET_ALL_ESIGN_AGREEMENT_ENDPOINT = "/api/surepass/data/agreement/getAllAgreements"
export const GET_ALL_ESIGN_MERCHANT_ENDPOINT = "/api/surepass/data/agreement/getMerchant"
export const GET_ALL_AGREEMENT_TYPE_ENDPOINT = "/api/surepass/data/agreement/getAgreementTypes/AGREEMENT"
export const ESIGN_CREATE_AGREEMENT = "/api/surepass/data/agreement/create";
export const ESIGN_INIITATE_AGREEMENT = "/api/surepass/data/agreement/initiate";
export const ESIGN_GET_AGREEMENT_STATUS = "/api/surepass/data/agreement/status";
export const ESIGN_SEND_SMS_EMAIL = "/api/surepass/data/agreement/sendSmsEmail";

export const ESTAMP_GET_ARTICLES = "/api/surepass/estamp/getArticles";
export const ESTAMP_CREATE_STAMP = "/api/surepass/estamp/data/create";
export const ESTAMP_GET_STATUS = "/api/surepass/estamp/data/getStatus";
export const ESTAMP_GET_LIST = "/api/surepass/estamp/data/estamplist";
export const ESTAMP_VIEW_FILE = "/api/surepass/estamp/data/file";

export const GET_ADMIN_ACCESS_ENDPOINT = "/admin/access/getAdminAccess";
export const BO_ACCESS_MAPPING_ENDPOINT = "/admin/access/boAccessMapping";
export const CREATE_ADMIN_USER_ENDPOINT = "/admin/access/createAdminUser";
export const UPDATE_ADMIN_USER_ENDPOINT = "/admin/access/updateAdminUser";

export const GET_UPI_V2_MERCHANTDATA_ENDPOINT = "/v2/getVpaMerchantData"
export const GET_UPI_V2_MULTIPLE_VPA_ENDPOINT = "/v2/createMultipleVpa"
export const GET_UPI_V2_DELETE_VPA_ENDPOINT = "/v2/createMultipleVpa"
export const GET_EMAIL_REPORT_ENDPOINT = "/send/getEmailReport"
export const GET_DEEMED_REFUND_TABLE_ENDPOINT = "/refund/getDeemedRefund"

export const CREATE_SUPPORT_TICKET_ENDPOINT = "/app/support/tickets"; 
export const SUPPORT_TICKET_LOOKUP_ENDPOINT = "/app/support/tickets/lookups";
export const SUPPORT_TICKET_HISTORY_ENDPOINT ="/app/support/tickets";
export const SUPPORT_TICKET_SCREENSHOT_ENDPOINT    = "/app/support/tickets";                  // POST
export const GET_SUPPORT_TICKETS_ENDPOINT = "/app/support/tickets";                       // GET ?status=
export const GET_SUPPORT_TICKETS_BY_MERCHANT_ENDPOINT = "/app/support/tickets/merchant";  // GET /{merchantId}
export const UPDATE_SUPPORT_TICKET_STATUS_ENDPOINT = "/app/support/tickets";    
export const SEARCH_SUPPORT_TICKETS_ENDPOINT = "/app/support/tickets/search"; // GET ?q=          // PATCH /{id}/status


// endpoints for mailer
export const CSV_VALIDATE_ENDPOINT = "/mailer/mail/api/merchant-groups/validate";
export const PREVIEW_MERCHANT_GROUP_ENDPOINT = "/mailer/mail/api/merchant-groups/preview";
export const SAVE_MERCHANT_GROUP_ENDPOINT = "/mailer/mail/api/merchant-groups";
export const GET_MERCHANT_GROUPS_ENDPOINT = "/mailer/mail/api/merchant-groups";
export const SEND_NOTIFICATION_CAMPAIGN_ENDPOINT = "/mailer/mail/api/notification-campaigns/send";
export const GET_CAMPAIGN_LOGS_ENDPOINT = "/mailer/mail/api/notification-campaigns/logs";
export const DOWNLOAD_CAMPAIGN_LOGS_CSV_ENDPOINT = "/mailer/mail/api/notification-campaigns/logs/csv";
export const GET_CAMPAIGN_RECIPIENTS_ENDPOINT = "/mailer/mail/api/notification-campaigns/logs"; // + /{campaignId}/recipients
export const DOWNLOAD_CAMPAIGN_RECIPIENTS_CSV_ENDPOINT = "/mailer/mail/api/notification-campaigns/logs"; // + /{campaignId}/recipients/csv
export const PREVIEW_RESELLER_GROUP_ENDPOINT = "/mailer/mail/api/merchant-groups/preview-resellers";
export const SAVE_RESELLER_GROUP_ENDPOINT = "/mailer/mail/api/merchant-groups/reseller-groups";
export const GET_ALL_NOTIFICATION_TEMPLATES_ENDPOINT = "/mailer/mail/api/notification-templates";
export const GET_NOTIFICATION_TEMPLATE_BY_ID_ENDPOINT = "/mailer/mail/api/notification-templates/"; // + templateId
export const CREATE_NOTIFICATION_TEMPLATE_ENDPOINT = "/mailer/mail/api/notification-templates";
// channel types
export const NOTIF_CHANNEL_EMAIL = "EMAIL";
export const NOTIF_CHANNEL_SMS = "SMS";
export const NOTIF_CHANNEL_BOTH = "BOTH";

export const GET_DOWNLOAD_FILE = "/api/files/downloadInvoiceFile";
export const DOWNLOAD_REPORT = "/api/files/downloadMprReport";
export const GET_ALL_INVOICE_TABLE_ENDPOINT = "/api/files/convenienceInvoiceList";
export const GET_REPORTS_API = "/api/report/list";
export const GENERATE_REPORT_API = "/api/report";
export const GET_MERCHANT_ACTIVE_ENDPOINT = "/api/admin/data/toggleMerchantConvAndSim";
export const GET_MERCHANT_CHARGEBACKFILE = "/api/admin/data/getMerchantChargebackFile";
export const GET_ALL_CHARGEBACK_TIMELINE_ENDPOINT = "/api/chargeback/getStatusHistory";
export const GET_BANK_DETAILS_ENDPOINT = "/api/admin/data/getBankAccountDetails";
export const GET_NAVIGATION_LIST_ENDPOINT = "/admin/access/getNavigationList"
export const GET_UPDATE_PASSWORD_ENDPOINT = "/admin/access/updatePassword"
export const GET_ALL_GROUP_TRANSACTION_ENDPOINT = "/api/admin/data/getAllGroupByTransactions"
export const GET_ALL_TRANSACTIONTODAY_COUNT_ENDPOINT = "/api/admin/data/getTodaysTnxCount"
export const GET_ALL_TRANSACTIONYEST_COUNT_ENDPOINT = "/api/admin/data/getYesterdayTnxCount"
export const GET_ALL_TRANSACTIONMONTH_COUNT_ENDPOINT = "/api/admin/data/getMonthsTnxCount"
export const GET_ALL_TRANSACTIONYEAR_COUNT_ENDPOINT = "/api/admin/data/getYearsTnxCount"
export const GET_ALL_TRANSACTIONALL_COUNT_ENDPOINT = "/api/admin/data/getAllTnxCount"
export const GET_ALL_TRANSACTION_COUNT_ENDPOINT = "/api/admin/data/getTnxCount"
export const GET_ALL_SETTLEMENT_COUNT_ENDPOINT = "/api/admin/data/getSettelmentCount"
export const GET_LIMITS_ENDPOINT = "/api/admin/data/getCreditLimitData"
export const GET_UPDATE_LIMITS_ENDPOINT = "/api/admin/data/updateCreditLimit"
export const GET_CREATE_LIMITS_ENDPOINT = "/rts/limit"
export const GET_TRANSACTION_LIMITS_ENDPOINT = "/api/admin/data/createTxnLimit"
export const GET_All_MERCHANT_CHAREGBACKFILES_ENDPOINT = "/api/chargeback/getAllMerchantChargebackFiles"
export const GET_All_CHARGEBACK_UPLOAD_FILE_ENDPOINT = "/api/chargeback/uploadFile/merchant"
export const GET_ALL_MERCHANT_LIST_ENDPOINT = "/api/admin/soundBox/getMerchantList"
export const GET_ALL_MERCHANT_VPA_LIST_ENDPOINT = "/api/admin/soundBox/getMerchantVpa"
export const GET_ALL_MERCHANT_SOND_BOX_MAPPING = "/api/admin/soundBox/soundBoxMapping"
export const GET_SOUND_BOX_ID_LIST_ENDPOINT = "/api/admin/soundBox/getSoundBoxNo"
export const GET_ALLOCATED_SOUNDBOX_LIST = "/api/admin/soundBox/getSoundBoxAllocatedList"
export const GET_INACTIVE_SOUNDBOX = "/api/admin/soundBox/inActiveSoundBox";
export const GET_SOUND_BOX_GET_PLANS_ENDPOINT = "/api/admin/soundBox/getAllplans"
export const GET_ALLOCATED_SOUNDBOXID_LIST = "/api/admin/soundBox/getSoundBoxId"
export const GET_ALLOCATED_SOUNDBOX_RENTALMAPPING = "/api/admin/soundBox/rentalMapping"
export const GET_RESELLER_BRANCHNAME_ENDPOINT = "/reseller/findResellerBranch"
export const GET_APPLICATION_ADMIN_USER = "/admin/application/getAdminUsers"
export const GET_APPLICATION_USER = "/admin/application/getApplications"
export const GET_ALL_SWITCH_APPLICATION = "/admin/application/switchApplication"
export const YES_BANK_FORMAT_REPORT_API = "/api/files/yesBankFormatReport";
export const SOUND_BOX_BULK_MAPPING = "/api/admin/soundBox/soundBoxBulkMapping"

export const GET_MCC_DESC= "/api/admin/data/mccCodeDesc"

export const GET_DEVICE_SOUNDBOX_LANG_LIST_ENDPOINT = "/api/admin/soundBox/soundboxLanguageList"
export const GET_DEVICE_SOUNDBOX_LANG_ENDPOINT = "/api/admin/soundBox/soundboxLanguage"

export const GET_ALL_TNC_ENDPOINT = "/api/admin/data/getTnCLog";
export const GET_ALL_CREATE_TNC_ENDPOINT = "/api/admin/data/makerCreateTnC";
export const GET_ALL_UPDATE_TNC_ENDPOINT = "/api/admin/data/checkerUpdateTnC";


export const GET_ALL_REFUND_TABLE_ENDPOINT= "/refund/getRefundTable";
export const GET_ALL_BACTCH_ADMIN_TABLE_ENDPOINT = "/refund/batchAdminAction";

export const GET_UPLOAD_REFUND_FILE_ENDPOINT = "/refund/uploadRefundFile"

export const ADMIN_UPDATE_MERCHANT = '/access/UpdateMerchantDetails';
export const GET_MRCHNT_APP_STATUS_ENDPOINT = '/api/merchant/application/getApplicationLog';
export const UPDATE_MRCHNT_USER_ENDPOINT = '/api/merchant/application/updateStatus/user';
export const UPDATE_MRCHNT_SUPER_ENDPOINT = '/api/merchant/application/updateStatus/super';
export const UPDATE_MRCHNT_FILE_STATUS = '/api/merchant/application/updateFileStatus';
export const GET_SUBSTATUS_ENDPOINT = '/admin/ui/getSubStatusList';
export const UPLOAD_MPR_ENDPOINT = "/ftx/data/uploadMpr";
export const UPLOAD_ADJ_ENDPOINT = "/ftx/data/adjustmentFile/upload";
export const CLEAR_MPR_ENDPOINT = "/ftx/data/clearMpr";
export const DO_RECON_ENDPOINT = "/ftx/data/recon";
export const GET_RECON_ENDPOINT = "/ftx/data/getRecon";
export const GET_SETTLE_GRP_ENDPOINT = "/ftx/data/getSettle";
export const GET_PG_DAILY_SETTLE_ENDPOINT = "/ftx/data/getDailySettle";
export const GET_PG_SETTLEMENT_DATA_ENDPOINT = "/ftx/data/getPgSettlementData";
export const GET_ADJUSTMENT_VIEW_ENDPOINT = "/ftx/data/adjustmentFile/view";
export const GET_PG_SPLIT_SETTLEMENT_DATA_ENDPOINT = "/ftx/data/getPgSplitSettlementData";
export const BALANCE_CHECK_ENDPOINT = "/ftx/balanceCheck";
export const GET_PIE_CHART_ENDPOINT = "/api/admin/data/getPieChartBothTxnData"

export const ECOLLECT_SETTLEMENT_UPLOAD_MPR = "/yb/ecollect/settlement/uploadEcollectMpr"
export const ECOLLECT_SETTLEMENT_CLEAR_MPR = "/yb/ecollect/settlement/clearMpr"
export const ECOLLECT_SETTLEMENT_DATA = "/yb/ecollect/settlement/getEcollectSttlementData"
export const ECOLLECT_SETTLEMENT_RECORN = "/yb/ecollect/settlement/recon"

export const FTX_BENE_CREATE_ENDPOINT = "/ftx/beneCreate";
export const GET_ACCESS_EMAIL = "/access/updateEmail";
export const GET_ACCESS_EMAIL_CONFIGURE = "/access/emailConfiguration";
export const GET_EMAIL_CONFIGURE = "/access/getEmailConfiguration";
export const GET_UPDATE_EMAIL_CONFIGURE = "/access/updateEmailStatus";
export const FTX_BENE_FETCH_ENDPOINT = "/ftx/beneFetch";

export const FTX_STATUS_CHECK = "/ftx/checkStatusUI";
export const FTX_PAY_BENE = "/ftx/payBene";
export const FTX_BULK_SETTLE_ENDPOINT = "/ftx/data/bulkSettle";

export const  CBK_GET_ALL_CHARGEBACKS_ENDPOINT = "/api/admin/data/getAllChargebacks";

// Application Types
export const APP_TYPE_DSB = "DSB";
export const APP_TYPE_PENDING = "PENDING";
export const APP_TYPE_RECFB = "RECFB";
export const APP_TYPE_REJFB = "REJFB";
export const APP_TYPE_BOS_APPROVAL = "BOS_APPROVAL";
export const APP_TYPE_BOS_REJECTION = "BOS_REJECTION";
export const APP_TYPE_REJECTED = "REJECTED";
export const APP_TYPE_SMSA = "SMSA";
export const APP_SEND_BY_TO_MERCHNAT = "BACK_TO_MERCHANT";

// FILE Type
export const GST_FILE = 'gstFile';
export const PAN_FILE = 'panFile';
export const AADHAR_FILE = 'aadhaarFile';
export const ADDRESS_FILE = 'addressFile'
export const AOA_FILE = 'aoaFile';
export const CHEQUE_FILE = 'cheqFile';
export const COI_FILE = 'coiFile';
export const LLP_FILE = 'llpFile';
export const OWBERPAN_FILE = 'ownerPanFile';
export const COMPANYPAN_FILE = 'companyPanFile';
export const HUFDEED_FILE = 'hufDeedFile';
export const DEED_FILE = 'deedFile';
export const MOA_FILE = 'moaFile';
export const REGISTRATION_FILE = 'registrationFile';
export const PARTNERSHIP_DEED_FILE = "partnershipDeedFile";
export const AOP_DEED_FILE = "aopDeedFile";
export const PHOTO_FILE = "photoFile";
export const MERCHANT_PHOTO = "MERCHANT_PHOTO";
export const AGREEMENT_FILE = "MERCHANT_AGREEMENT";
export const ADDITIONAL_DOCUMENT_ONE = "additionalDocument1";
export const ADDITIONAL_DOCUMENT_TWO = "additionalDocument2";
export const ADDITIONAL_DOCUMENT_THREE = "additionalDocument3";
export const ADDITIONAL_DOCUMENT_FOUR = "additionalDocument4";
export const UDYAM_FILE = "udyam";
export const SHOP_ESTABLISHMENT_FILE = "shop_establishment";
export const SALES_INCOME_TAX_RETURN_FILE = "sales_income_tax_return";
export const GST_CERTIFICATE_FILE = "gst_certificate";
export const TAX_REGISTRATION_FILE = "tax_registration";
export const IEC_CERTIFICATE_FILE = "iec_certificate";
export const ITR_COMPLETE_FILE = "itr_complete";
export const UTILITY_BILL_FILE = "utility_bill";
export const UPDATE_BANK = "UPDATE_BANK";
export const HTTP_POST = 'POST';
export const HTTP_GET = 'GET';
export const HTTP_PUT = 'PUT';
export const HTTP_DELETE = 'DELETE';

// HTTP Header
export const HTTP_CREDS_SAME_ORIGIN = 'same-origin';
export const HTTP_HEADER_CONTENT_TYPE = 'Content-Type';
export const HTTP_CONTENT_TYPE_APP_JSON = 'application/json';
export const X_JWS_SIGNATURE_HEADER = 'X-Jws-Signature';

// COOKIE STORE VALUES
export const X_JWS_SIGNATURE_COOKIE = 'x-signature';
export const X_JWS_USER_ID = 'x-j-user-id';
export const USER_FULL_NAME = 'USER_FULL_NAME';
export const USER_OTP = 'USER_OTP';
export const USER_CAPTURE = 'USER_CAPTURE';

// Cashfree API Status
export const CF_STATUS_VALID = "VALID";
export const CF_STATUS_INVALID = "INVALID";

// INVOICE MASTER DOWNLOAD FILE FLAG
export const INVOICE_TYPE_MERCH_REPORT = "MERCH_REPORT";
export const INVOICE_TYPE_CONV_REPORT = "CONV_REPORT";
export const INVOICE_TYPE_TRGST_REPORT = "TRGST_REPORT";
export const INVOICE_TYPE_RBI_REPORT = "RBI_REPORT";

export const CF_STATUS_EXIST = true;


//HTTP Status Codes
export const HTTP_STTS_CODE_200 = 200;
export const HTTP_STTS_CODE_400 = 400;
export const HTTP_STTS_CODE_401 = 401;
export const HTTP_STTS_CODE_402 = 402;
export const HTTP_STTS_CODE_403 = 403;
export const HTTP_STTS_CODE_429 = 429;
export const HTTP_STTS_CODE_500 = 500;

export const STATUS_CODE_OK = "OK";

export const COOKIE_KEY_PROCESS = "PROCESS";
export const COOKIE_VALUE_EDITPROCESS = "EDITPROCESS";

export const COUTRY_CODE_91 = "+91";

// Location names
export const API_NAME_ASIA = "ASIA";
export const API_NAME_INDIA = "INDIA";
export const API_TYPE_COUNTRY = "COUNTRY";
export const API_TYPE_STATE = "STATE";

export const API_BIZ_CATEGORY = "BIZ_CATEGORY";
export const API_BIZ_SUB_CATEGORY = "BIZ_SUB_CATEGORY";
export const API_BIZ_PARENT_CATEGORY = "PARENT_CATEGORY";
export const API_BIZ_MODAL = "BIZ_MODAL";

export const API_NAME_SUPCARD2BTYPE = "SUP_CARD_2_BTYPE";
export const API_PARAMTYPE_BTYPE = "B_TYPE";
export const API_NAME_MERCHANT_DASHBOARD = "MERCHANT_DASHBOARD";
export const API_PARAMTYPE_PRODUCTS = "PRODUCTS";

// user account status types
export const ACTIVE = "ACTIVE";
export const INACTIVE = "INACTIVE";
export const USER_ACC_STATUS_ACTIVE = "ACTIVE";
export const USER_ACC_STATUS_PENDING = "PENDING";
export const USER_ACC_STATUS_INITIAL = "INITIAL";
export const USER_POLICY_TERMSNCOND = "TERMSNCOND";
export const USER_POLICY_PRIVPOLICY = "PRIVPOLICY";





// Business types for pan and onboarding
export const BTYPE_PROPREITOR = "PROPRIETOR";
export const BTYPE_INDIVIDUAL = "INDIVIDUAL";
export const BTYPE_PVTLTD = "PRIVATE LIMITED";
export const BTYPE_PUBLTD = "PUBLIC LIMITED";
export const BTYPE_PARTNERSHIP = "PARTNERSHIP";
export const BTYPE_LLP = "LLP";
export const BTYPE_GOVT = "GOVT";
export const BTYPE_HUF = "HUF";
export const BTYPE_TRUST = "TRUST";
export const BTYPE_LOCAL_AUTHORITY = "LOCAL AUTHORITY";
export const BTYPE_ARTIFICIAL_JURIDICAL_PERSON = "ARTIFICIAL JURIDICAL PERSON";
export const BTYPE_ASSOCIATION_OF_PERSONS = "ASSOCIATION OF PERSONS";
export const BTYPE_BODY_OF_INDIVIDUALS = "BODY OF INDIVIDUALS";

export const BIZ_CATEGORY_B2B = "B2B";
export const BIZ_SEGMENT_B2B_MERCHANT = "B2B Merchant";
export const BIZ_SEGMENT_EDUCATION = "Education";


// Error messages
export const ERR_PROCESSING_REQ = "Error processing your request, Please try again later!"
export const ERR_VALID_LINK_FORMAT = "Link needs to be in valid format, https required for sites.";
export const ERR_INVALID_EMAIL = "Invalid Email Address";
export const ERR_BOTH_LINK_REQUIRED = "Website or Application link Required";
export const ERR_VALID_WEB_LINK_FORMAT = "The website link must be in a valid format and cannot contain spaces. It should start with 'https://'.";
export const ERR_VALID_APP_LINK_FORMAT = "The application link must be in a valid format and cannot contain spaces. It should start with 'https://'.";

export const ERR_FILE_SELECTED = "File not selected";
export const ERR_FILE_SIZE = "File Size must be less than 2 MB";
export const ERR_FILE_FORMAT = "File must be in pdf format only";
export const ERR_NOT_FOUND = "Not Found";
export const RISK_SCORE_GET_URL = "/merchant/risk/score";
export const RISK_SCORE_SAVE_URL = "/merchant/risk/score";
export const RE_KYC_MERCHNAT_URL = "/api/admin/data/getActiveMerchants/kyc"
export const RE_KYC_STATUS_SUB_ENDPOINT = "/merchant/risk/sumbit/kycstatus"

export const BULK_UPLOAD_MERCHANT_SCHEME_MAPPING_ENDPOINT = "/api/product/previewMerchantCsv";
export const BULK_MERCHANT_SCHEME_MAPPING_ENDPOINT = "/api/product/bulkMerchantSchemeMappingBySegment";

export const GET_INACTIVE_MERCHANTS_ENDPOINT = "/api/internal/data/inactive";
export const NOTIFY_INACTIVE_MERCHANTS_EMAIL_ENDPOINT = "/api/internal/data/notifyInactive/email";
export const NOTIFY_INACTIVE_MERCHANTS_SMS_ENDPOINT = "/api/internal/data/notifyInactive/sms";
export const GET_VPA_LIST_BY_MERCHANT_ID_ENDPOINT = "/v2/getVpaListByMerchantId";
export const UPDATE_MERCHANT_CONFIG_ENDPOINT = "/v2/updateMerchantConfig"; 
export const UPDATE_MERCHANT_STATUS_ENDPOINT = "/api/internal/data/updateMerchantStatus";
export const GET_PENDING_MERCHANTS_ENDPOINT = "/api/internal/data/v2/getPendingMerchants";

export const COOKIE_OPTIONS:CookieAttributes = {
    secure: true,
    sameSite: "Strict",
    expires: new Date(Date.now() + 24 * 60 * 60 * 1000)
};

export const COOKIE_SECURE:CookieAttributes = {
    secure: true,
    sameSite: "Strict",
};